<span class="material-icons">{{name}}</span>
